import { Dropdown as AntdDropdown, DropdownProps } from 'antd'
import './Dropdown.less'

export const Dropdown = (props: DropdownProps) => <AntdDropdown {...props} />

export default Dropdown
